export const looksLikeJwt = (t) =>
  typeof t === "string" &&
  t &&
  t !== "undefined" &&
  t !== "null" &&
  t.split(".").length === 3;

export const getAccessToken = () =>
  localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

export const getUserStatus = () =>
  localStorage.getItem("user_status") || sessionStorage.getItem("user_status");

export const getUserTimeZone = () => {
  if (typeof window === "undefined") return "UTC";
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
};

export const buildHeaders = (token, extra = {}) => {
  const headers = {
    ...extra,
    "User-Timezone": getUserTimeZone(),
  };

  if (!("Content-Type" in headers)) {
    headers["Content-Type"] = "application/json";
  }

  if (headers["Content-Type"] === undefined) {
    delete headers["Content-Type"];
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const normalizeCode = (code) => Number(code);

export const inferUserStatusFromCode = (code) => {
  const numericCode = normalizeCode(code);

  if ([212, 214, 216, 218, 220].includes(numericCode)) return "individual";
  if ([224, 226, 228, 230, 232].includes(numericCode)) return "salon";
  if ([234, 236, 266].includes(numericCode)) return "worker";

  return null;
};

export const getRouteFromCode = (code) => {
  const numericCode = normalizeCode(code);

  switch (numericCode) {
    case 222:
      return "/account-type-select";

    case 212:
      return "/biography-individual";
    case 214:
      return "/choose-niche";
    case 216:
      return "/my-services";
    case 218:
      return "/working-days";
    case 220:
      return "/booking-settings";

    case 224:
      return "/biography-salon";
    case 226:
      return "/choose-niche";
    case 228:
      return "/my-services";
    case 230:
      return "/working-days";
    case 232:
      return "/booking-settings";

    case 234:
      return "/worker-biography";
    case 236:
    case 266:
      return "/working-days";

    default:
      return null;
  }
};

export const getAllowedRoutesForCode = (code) => {
  const numericCode = normalizeCode(code);

  switch (numericCode) {
    case 222:
      return ["/account-type-select"];

    case 212:
      return ["/biography-individual", "/biography"];
    case 214:
      return ["/choose-niche", "/subniche-select"];
    case 216:
      return ["/suggested-services", "/my-services", "/services"];
    case 218:
      return ["/working-days"];
    case 220:
      return ["/booking-settings", "/finish-registration"];

    case 224:
      return ["/biography-salon"];
    case 226:
      return ["/choose-niche", "/subniche-select"];
    case 228:
      return ["/suggested-services", "/my-services", "/services"];
    case 230:
      return ["/working-days"];
    case 232:
      return ["/booking-settings", "/finish-registration"];

    case 234:
      return ["/worker-biography"];
    case 236:
    case 266:
      return ["/working-days", "/finish-registration"];

    default:
      return [];
  }
};

export const isOnboardingRoute = (pathname) => {
  const onboardingRoutes = [
    "/account-type-select",
    "/biography",
    "/biography-individual",
    "/biography-salon",
    "/biography-member",
    "/worker-biography",
    "/choose-niche",
    "/subniche-select",
    "/suggested-services",
    "/my-services",
    "/services",
    "/working-days",
    "/booking-settings",
    "/finish-registration",
  ];

  return onboardingRoutes.includes(pathname);
};